export const Theme = {
    colors: {
      background: "#ccc",
      light: "#eee",
      lightHover: "#ccc",
      lightActive: "#aaa",
      lightSecondary: "#ddd",
      lightBorder: "#ccc",
      dark: "#06283D",
      darkHover: "#3BACB6",
      darkActive: "#111",
      blue: "#143E72",
      primary: "#1ba148",
      primaryHover: "#27AA80",
      primaryActive: "#098026",
      secondary: "#c25c0e",
      secondaryHover: "#FC7E2F",
      secondaryActive: "#a03a0c",
      red: "#b3211e",
      redHover: "#F90716",
      redActive: "#91000c",
    },
  };
  
  export default Theme;
  